import type { FormEntryIndex } from '@cognitoforms/types/server-types/forms/model/form-entry-index';
import type { FormEntry } from '@cognitoforms/types/server-types/forms/model/form-entry';
import type { UserEntryViewMeta } from '@cognitoforms/types/server-types/core/services/user-entry-view-meta';
import type { WorkflowRole } from '@cognitoforms/types/server-types/forms/model/workflow-role';
import type { GlobalStore } from 'src/stores/global-store';
import type { EntryKey } from '@cognitoforms/types/server-types/forms/services/entry-key';
import type { Ref } from 'vue';

export function getRoleInfo(taskView : UserEntryViewMeta) : WorkflowRole {
	return {
		Id: taskView.RoleId
	} as WorkflowRole;
};

export function getViewId(index: FormEntryIndex) : string {
	return index.Id.split('|')[0];
};

export function getViewToken(viewId : string, taskViews: Ref<UserEntryViewMeta[]>): string {
	return taskViews.value.find(taskView => taskView.Id === viewId)?.Token;
};

export function getTaskViewRoleId(viewId: string, taskViews: Ref<UserEntryViewMeta[]>): number {
	return taskViews.value.find(taskView => taskView.Id === viewId).RoleId;
};

export function getEntryId(index: FormEntryIndex) : string {
	return index.EntityId;
};

export function getEntryKey(entry: FormEntry & { $etag: string }) : EntryKey {
	return {
		EntryId: entry.Id,
		EntryETag: entry.$etag
	} as EntryKey;
};

export function getEntryKeyFromIndex(index: FormEntryIndex) : EntryKey {
	return {
		EntryId: getEntryId(index),
		EntryETag: index.EntryETag
	} as EntryKey;
};

export function getViewName(index: FormEntryIndex, taskViews: UserEntryViewMeta[]) : string {
	const viewId = getViewId(index);
	return taskViews.find(taskView => taskView.Id === viewId).Name;
};

export function getFormId(index: FormEntryIndex) : string {
	return index.EntityId.split('-')[0];
};

function getForm(index: FormEntryIndex, globalStore: GlobalStore) {
	return globalStore.forms[getFormId(index)];
}

export function getFormName(index: FormEntryIndex, globalStore: GlobalStore) : string {
	return getForm(index, globalStore).Name;
};

export function getFormTitle(index: FormEntryIndex, globalStore: GlobalStore) : string {
	const form = getForm(index, globalStore);
	return form.Title;
};

export function getEntryViewRoute(index : FormEntryIndex, globalStore: GlobalStore) : string {
	const form = getForm(index, globalStore);
	const entryView = form.EntryViews.find(view => view.Id === getViewId(index));
	return '/' + globalStore.organization.Code + '/' + form.InternalName + '/' + entryView.Id.split('-')[1] + '-' + entryView.InternalName;
};